// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"179":"main","328":"admin","625":"main_app"}[chunkId] || chunkId) + "." + {"179":"9aed2646","328":"b6c79ce0","571":"fb7b74d1","625":"bdf04201"}[chunkId] + ".js";
};